import Payment from './Payment.js'

export default Payment;